import React, { useState } from 'react';
import { styled } from '@linaria/react';
import useTranslation from 'next-translate/useTranslation';
import { useAtom } from 'jotai';
import _uniqBy from 'lodash/uniqBy';
import { FormControl } from '@spaceshipapp/cambridge';
import Autocomplete from '../../../components/Autocomplete';
import useYup from '../../../hooks/useYup';
import { documentAtom } from '../../../contexts/shipment';

// TODO: handle available options in Core backend
const defaultOptions = ['Application form', 'Certificates', 'Contracts', 'Letters'];

interface Props {
  errors?: ReturnType<typeof useYup>['errors'];
}

const Description: React.FC<Props> = ({ errors }) => {
  const { t } = useTranslation('common');
  const [description, setDescription] = useAtom(documentAtom);
  const [currentValue, updateCurrentValue] = useState(description);
  const searchOptions = { threshold: 0.3 };
  const options = currentValue
    ? _uniqBy([currentValue, ...defaultOptions], (e) => e.toLowerCase())
    : defaultOptions;

  const handleBlur = (description?: string | null) => {
    const itemDescription = description || '';
    updateCurrentValue(itemDescription);
    setDescription(itemDescription);
  };

  return (
    <FormControl
      errorMessage={errors?.documentItem && t(errors?.documentItem as string)}
      helpMessage={<HelpMessage>{t('Items.subtextEnvelopeDescription')}</HelpMessage>}
    >
      <Autocomplete
        id="description"
        name="description"
        label={t('Items.formLabelEnvelopeDescription')}
        selectedItem={description}
        items={options}
        onSelectedItemChange={handleBlur}
        onBlur={(e) => handleBlur(e.target.value)}
        onInputValueChange={updateCurrentValue}
        searchOptions={searchOptions}
        isError={!!errors?.documentItem}
      />
    </FormControl>
  );
};

const HelpMessage = styled.span`
  white-space: pre-wrap;
`;

export default Description;
